import {AxiosRequestConfig} from 'axios'
import RequestBase from '../../../api/RequestBase'

const BASE_URL = '/download'

const resolveKey = (key: string, config?: AxiosRequestConfig) => {
  return RequestBase.get(`${BASE_URL}/resolve`, {
    ...config,
    params: {key},
  })
}

const DownloadService = {
  resolveKey,
}

export default DownloadService
